import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table, Button, Modal, Form, Input, Select, message,
  Card, Tag, Space, Popconfirm, Row, Col, InputNumber,
  DatePicker, Divider, Steps, Radio, Checkbox, Input as AntInput, Collapse,
  Typography
} from 'antd';

const { TextArea } = AntInput;
const { Panel } = Collapse;
import {
  PlusOutlined, DeleteOutlined, EditOutlined, EyeOutlined,
  RocketOutlined, PlusCircleOutlined, MinusCircleOutlined
} from '@ant-design/icons';
import api from '../utils/api';

const { Option } = Select;
const { Step } = Steps;

// 广告目标选项
const objectives = [
  { value: 'OUTCOME_TRAFFIC', label: '流量' },
  { value: 'OUTCOME_SALES', label: '销售' },
  { value: 'OUTCOME_LEADS', label: '潜在客户' },
  { value: 'OUTCOME_AWARENESS', label: '品牌认知' },
  { value: 'OUTCOME_ENGAGEMENT', label: '互动' },
  { value: 'OUTCOME_APP_PROMOTION', label: '应用推广' },
];

// 出价策略选项
const bidStrategies = [
  { value: 'LOWEST_COST_WITHOUT_CAP', label: '最低成本无上限' },
  { value: 'COST_CAP', label: '成本上限' },
  { value: 'LOWEST_COST_WITH_BID_CAP', label: '最低成本带出价上限' },
  { value: 'LOWEST_COST_WITH_MIN_ROAS', label: '最低成本带最低ROAS' },
];

// 广告系列竞价策略选项
const campaignBidStrategies = [
  { value: 'HIGHEST_VOLUME_OR_VALUE', label: '最高数量或价值' },
  { value: 'LOWEST_COST', label: '最低成本' },
  { value: 'COST_CAP', label: '成本上限' },
  { value: 'BID_CAP', label: '出价上限' },
  { value: 'MIN_ROAS', label: '最低ROAS' },
];

// 计费事件选项
const billingEvents = [
  { value: 'IMPRESSIONS', label: '展示' },
  { value: 'LINK_CLICKS', label: '链接点击' },
  { value: 'APP_INSTALLS', label: '应用安装' },
];

// 优化目标选项
const optimizationGoals = [
  { value: 'LINK_CLICKS', label: '链接点击' },
  { value: 'IMPRESSIONS', label: '展示' },
  { value: 'REACH', label: '覆盖人数' },
  { value: 'OFFSITE_CONVERSIONS', label: '转化' },
];

// 转化发生位置
const conversionLocations = [
  { value: 'WEBSITE', label: '网站' },
  { value: 'APP', label: '应用' },
  { value: 'MESSENGER', label: 'Messenger' },
  { value: 'WHATSAPP', label: 'WhatsApp' },
  { value: 'ON_AD', label: '广告上' },
];

// 成效目标 (Campaign performance_goal)
const performanceGoals = [
  { value: 'MAXIMIZE_CONVERSIONS', label: '转化量最大化' },
  { value: 'MAXIMIZE_CONVERSION_VALUE', label: '转化价值最大化' },
  { value: 'MAXIMIZE_LINK_CLICKS', label: '链接点击量最大化' },
  { value: 'MAXIMIZE_IMPRESSIONS', label: '展示次数最大化' },
  { value: 'MAXIMIZE_REACH', label: '覆盖人数最大化' },
  { value: 'MAXIMIZE_THRUPLAY', label: '完整观看量最大化' },
  { value: 'MAXIMIZE_STORE_VISITS', label: '店铺访问量最大化' },
];

// 归因设置
const attributionSettings = [
  { value: '7D_CLICK_1D_VIEW', label: '点击后7天/浏览后1天' },
  { value: '1D_CLICK_1D_VIEW', label: '点击后1天/浏览后1天' },
  { value: '7D_CLICK', label: '仅点击后7天' },
  { value: '1D_CLICK', label: '仅点击后1天' },
];

// 语言选项（已弃用，改为从 Facebook API 动态搜索）
// const languages = [
//   { value: 'zh', label: '中文' },
//   { value: 'en', label: '英语' },
//   { value: 'ja', label: '日语' },
//   { value: 'ko', label: '韩语' },
//   { value: 'fr', label: '法语' },
//   { value: 'de', label: '德语' },
//   { value: 'es', label: '西班牙语' },
// ];

// 设备选项
const devices = [
  { value: 'mobile', label: '手机' },
  { value: 'desktop', label: '桌面电脑' },
  { value: 'tablet', label: '平板' },
];

// 操作系统选项
const operatingSystems = [
  { value: 'iOS', label: 'iOS' },
  { value: 'Android', label: 'Android' },
  { value: 'Windows', label: 'Windows' },
  { value: 'Mac', label: 'Mac OS' },
];

// 国家选项
const countries = [
  { value: 'US', label: '美国' },
  { value: 'CA', label: '加拿大' },
  { value: 'GB', label: '英国' },
  { value: 'AU', label: '澳大利亚' },
  { value: 'DE', label: '德国' },
  { value: 'FR', label: '法国' },
  { value: 'JP', label: '日本' },
  { value: 'KR', label: '韩国' },
];

const AdSeriesTemplates = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [adSetConfigs, setAdSetConfigs] = useState([{ key: 0 }]);
  const [budgetMode, setBudgetMode] = useState('CBO');
  const isInitialEditLoad = React.useRef(false);
  const [createAdVisible, setCreateAdVisible] = useState(false);
  const [createAdTemplate, setCreateAdTemplate] = useState(null);
  const [createAdForm] = Form.useForm();
  const [adAccounts, setAdAccounts] = useState([]);
  const [pixels, setPixels] = useState([]);
  const [interestOptions, setInterestOptions] = useState([]);
  const [behaviorOptions, setBehaviorOptions] = useState([]);
  const [localeOptions, setLocaleOptions] = useState([]);
  const [searchingInterests, setSearchingInterests] = useState(false);
  const [searchingBehaviors, setSearchingBehaviors] = useState(false);
  const [searchingLocales, setSearchingLocales] = useState(false);
  const interestSearchTimer = React.useRef(null);
  const behaviorSearchTimer = React.useRef(null);
  const localeSearchTimer = React.useRef(null);

  // 获取模板列表
  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const response = await api.get('/ad-series-templates/');
      setTemplates(response.data);
    } catch (error) {
      message.error('获取模板列表失败');
    } finally {
      setLoading(false);
    }
  };

  // 获取素材列表
  const fetchMaterials = async () => {
    try {
      const response = await api.get('/materials/');
      setMaterials(response.data);
    } catch (error) {
      message.error('获取素材列表失败');
    }
  };

  // 获取广告账户列表
  const fetchAdAccounts = async () => {
    try {
      const response = await api.get('/ad-accounts/');
      setAdAccounts(response.data);
    } catch (error) {
      message.error('获取广告账户列表失败');
    }
  };

  // 获取 Pixel 列表
  const fetchPixels = async () => {
    try {
      const response = await api.get('/business-managers/pixels/list');
      setPixels(response.data);
    } catch (error) {
      message.error('获取 Pixel 列表失败');
    }
  };

  // 搜索兴趣（防抖）
  const debounceSearchInterests = (keyword) => {
    if (interestSearchTimer.current) clearTimeout(interestSearchTimer.current);
    if (!keyword || keyword.length < 2) {
      setInterestOptions([]);
      return;
    }
    interestSearchTimer.current = setTimeout(async () => {
      setSearchingInterests(true);
      try {
        const response = await api.get('/business-managers/targeting/search/interests', {
          params: { q: keyword, limit: 20 }
        });
        setInterestOptions(response.data.results || []);
      } catch (error) {
        // 静默失败
      } finally {
        setSearchingInterests(false);
      }
    }, 500);
  };

  // 搜索行为（防抖）
  const debounceSearchBehaviors = (keyword) => {
    if (behaviorSearchTimer.current) clearTimeout(behaviorSearchTimer.current);
    if (!keyword || keyword.length < 2) {
      setBehaviorOptions([]);
      return;
    }
    behaviorSearchTimer.current = setTimeout(async () => {
      setSearchingBehaviors(true);
      try {
        const response = await api.get('/business-managers/targeting/search/behaviors', {
          params: { q: keyword, limit: 50 }
        });
        setBehaviorOptions(response.data.results || []);
      } catch (error) {
        // 静默失败
      } finally {
        setSearchingBehaviors(false);
      }
    }, 500);
  };

  // 搜索语言/地区（防抖）
  const debounceSearchLocales = (keyword) => {
    console.log('搜索语言:', keyword);
    if (localeSearchTimer.current) clearTimeout(localeSearchTimer.current);
    if (!keyword || keyword.length < 1) {
      setLocaleOptions([]);
      return;
    }
    localeSearchTimer.current = setTimeout(async () => {
      setSearchingLocales(true);
      try {
        const response = await api.get('/business-managers/targeting/search/locales', {
          params: { q: keyword, limit: 50 }
        });
        console.log('语言搜索结果:', response.data);
        setLocaleOptions(response.data.results || []);
      } catch (error) {
        console.error('搜索语言失败:', error);
      } finally {
        setSearchingLocales(false);
      }
    }, 500);
  };

  useEffect(() => {
    fetchTemplates();
    fetchMaterials();
    fetchAdAccounts();
    fetchPixels();
  }, []);

  // 监听 adset_count 变化，自动调整 AdSet 表单数量（仅创建模式，编辑模式由 editingTemplate 触发）
  const adsetCountValue = Form.useWatch('adset_count', form);
  useEffect(() => {
    if (modalVisible && !isInitialEditLoad.current && !editingTemplate) {
      const count = Number(adsetCountValue) || 1;
      setAdSetConfigs(prev => {
        const currentCount = prev.length;
        if (count === currentCount) return prev;
        if (count > currentCount) {
          const newConfigs = [...prev];
          for (let i = currentCount; i < count; i++) {
            newConfigs.push({ key: i });
          }
          return newConfigs;
        }
        return prev.slice(0, count);
      });
    }
  }, [adsetCountValue, modalVisible, editingTemplate]);

  // 编辑回填：当 adSetConfigs 重建完成后，回填 AdSet 数据
  useEffect(() => {
    if (!isInitialEditLoad.current || !editingTemplate || !modalVisible) return;

    const adsetConfigsData = editingTemplate.adset_configs || [];
    const adSetValues = {};

    adSetConfigs.forEach((adSet, index) => {
      const config = adsetConfigsData[index];
      if (config) {
        adSetValues[`adset_name_${index}`] = config.name;
        adSetValues[`adset_daily_budget_${index}`] = config.daily_budget;
        adSetValues[`adset_lifetime_budget_${index}`] = config.lifetime_budget;
        adSetValues[`adset_bid_amount_${index}`] = config.bid_amount;
        adSetValues[`adset_bid_strategy_${index}`] = config.bid_strategy;
        adSetValues[`adset_billing_event_${index}`] = config.billing_event;
        adSetValues[`adset_optimization_goal_${index}`] = config.optimization_goal;
        // 转化设置
        adSetValues[`adset_conversion_location_${index}`] = config.conversion_location ?? 'WEBSITE';
        adSetValues[`adset_performance_goal_${index}`] = config.performance_goal ?? 'CONVERSIONS';
        adSetValues[`adset_pixel_id_${index}`] = config.pixel_id;
        adSetValues[`adset_conversion_event_${index}`] = config.conversion_event ?? 'PURCHASE';
        adSetValues[`adset_attribution_setting_${index}`] = config.attribution_setting ?? '7D_CLICK_1D_VIEW';
        // 定向设置
        adSetValues[`adset_age_min_${index}`] = config.targeting?.age_min ?? 18;
        adSetValues[`adset_age_max_${index}`] = config.targeting?.age_max ?? 65;
        adSetValues[`adset_genders_${index}`] = config.targeting?.genders ?? [0, 1];
        adSetValues[`adset_countries_${index}`] = config.targeting?.geo_locations?.countries || ['US'];
        // 语言 - 兼容旧数据（对象数组或字符串数组），使用 labelInValue 格式
        adSetValues[`adset_languages_${index}`] = (config.targeting?.locales || []).map(l => {
          if (typeof l === 'object' && l.id) return { value: String(l.id), label: l.name || String(l.id) };
          return { value: String(l), label: String(l) };
        });
        // 兴趣/行为 - 转换为 labelInValue 格式（兼容旧数据）
        adSetValues[`adset_interests_${index}`] = (config.targeting?.interests || []).map(i => {
          if (typeof i === 'object' && i.id) return { value: i.id, label: i.name || i.id };
          return { value: i, label: i };
        });
        adSetValues[`adset_behaviors_${index}`] = (config.targeting?.behaviors || []).map(b => {
          if (typeof b === 'object' && b.id) return { value: b.id, label: b.name || b.id };
          return { value: b, label: b };
        });
        adSetValues[`adset_platforms_${index}`] = config.placements?.publisher_platforms || ['facebook', 'instagram'];
        // 赋能型受众功能
        adSetValues[`adset_advantage_audience_${index}`] = config.advantage_audience ?? 0;
        // 设备和操作系统
        adSetValues[`adset_devices_${index}`] = config.device_targeting?.devices || ['mobile', 'desktop'];
        adSetValues[`adset_os_${index}`] = config.device_targeting?.os || [];
        adSetValues[`adset_start_time_${index}`] = config.start_time;
        adSetValues[`adset_end_time_${index}`] = config.end_time;
      }
    });

    form.setFieldsValue(adSetValues);
    isInitialEditLoad.current = false;
  }, [adSetConfigs, editingTemplate, modalVisible, form]);

  // 保存Campaign设置（进入下一步）
  const handleSaveCampaign = async () => {
    try {
      // 验证Campaign必填字段
      const campaignValues = await form.validateFields([
        'name', 'objective', 'budget_mode'
      ]);
      
      // 进入AdSet设置步骤
      setCurrentStep(1);
      message.success('Campaign设置已保存，请继续配置AdSet');
    } catch (error) {
      // 验证失败，停留在当前步骤
      message.error('请填写必填项');
    }
  };

  // 提交表单（保存完整模板）
  const handleSubmit = async () => {
    try {
      // 获取所有表单字段值
      const values = form.getFieldsValue(true);
      console.log('Submit values:', values);
      
      // 构建 AdSet 配置（根据 adSetConfigs 数量遍历，与 adset_count 保持一致）
      const adsetConfigs = adSetConfigs.map((_, index) => ({
        name: values[`adset_name_${index}`] || `AdSet ${index + 1}`,
        daily_budget: values[`adset_daily_budget_${index}`],
        lifetime_budget: values[`adset_lifetime_budget_${index}`],
        bid_amount: values[`adset_bid_amount_${index}`],
        bid_strategy: values[`adset_bid_strategy_${index}`],
        billing_event: values[`adset_billing_event_${index}`],
        optimization_goal: values[`adset_optimization_goal_${index}`],
        // 转化设置
        conversion_location: values[`adset_conversion_location_${index}`] || 'WEBSITE',
        performance_goal: values[`adset_performance_goal_${index}`] || 'CONVERSIONS',
        pixel_id: values[`adset_pixel_id_${index}`],
        conversion_event: values[`adset_conversion_event_${index}`] || 'PURCHASE',
        attribution_setting: values[`adset_attribution_setting_${index}`] || '7D_CLICK_1D_VIEW',
        // 定向设置
        targeting: {
          geo_locations: {
            countries: values[`adset_countries_${index}`] || ['US']
          },
          age_min: values[`adset_age_min_${index}`] ?? 18,
          age_max: values[`adset_age_max_${index}`] ?? 65,
          genders: values[`adset_genders_${index}`] ?? [0, 1],
          locales: (values[`adset_languages_${index}`] || []).map(l => ({
            id: l.value || l,
            name: l.label || l
          })),
          interests: (values[`adset_interests_${index}`] || []).map(i => ({
            id: i.value || i,
            name: i.label || i
          })),
          behaviors: (values[`adset_behaviors_${index}`] || []).map(b => ({
            id: b.value || b,
            name: b.label || b
          })),
        },
        placements: {
          publisher_platforms: values[`adset_platforms_${index}`] || ['facebook', 'instagram']
        },
        // 赋能型受众功能
        advantage_audience: values[`adset_advantage_audience_${index}`] ?? 0,
        // 设备和操作系统
        device_targeting: {
          devices: values[`adset_devices_${index}`] || ['mobile', 'desktop'],
          os: values[`adset_os_${index}`] || [],
        },
        start_time: values[`adset_start_time_${index}`]?.format?.() || values[`adset_start_time_${index}`],
        end_time: values[`adset_end_time_${index}`]?.format?.() || values[`adset_end_time_${index}`],
      }));

      const payload = {
        name: values.name,
        description: values.description,
        objective: values.objective,
        buying_type: values.buying_type || 'AUCTION',
        budget_mode: values.budget_mode,
        campaign_daily_budget: values.budget_mode === 'CBO' ? values.campaign_daily_budget : null,
        campaign_lifetime_budget: values.budget_mode === 'CBO' ? values.campaign_lifetime_budget : null,
        bid_strategy: values.bid_strategy,
        bid_amount: values.bid_amount,
        advantage_campaign_budget: values.advantage_campaign_budget,
        campaign_bid_strategy: values.campaign_bid_strategy,
        special_ad_categories: values.special_ad_categories || [],
        campaign_start_time: values.campaign_start_time?.format?.() || values.campaign_start_time,
        campaign_stop_time: values.campaign_stop_time?.format?.() || values.campaign_stop_time,
        adset_configs: adsetConfigs,
        // 数量配置
        adset_count: values.adset_count || 1,
        ad_per_adset: values.ad_per_adset || 1,
        material_per_ad: values.material_per_ad || 1,
        body_count: values.body_count ?? 5,
        headline_count: values.headline_count ?? 5,
        description_count: values.description_count ?? 5,
        // 创意配置（可选）
        message_template: values.message_template || '',
        headline_template: values.headline_template || '',
        call_to_action: values.call_to_action || 'SEE_DETAILS',
        link_url: values.link_url || '',
        page_id: values.page_id || '',
      };

      if (editingTemplate) {
        await api.put(`/ad-series-templates/${editingTemplate.id}`, payload);
        message.success('更新成功');
      } else {
        await api.post('/ad-series-templates/', payload);
        message.success('创建成功');
      }

      setModalVisible(false);
      form.resetFields();
      setAdSetConfigs([{ key: 0 }]);
      setCurrentStep(0);
      setEditingTemplate(null);
      fetchTemplates();
    } catch (error) {
      const errorData = error.response?.data;
      
      // Handle Pydantic v2 validation errors
      if (errorData?.detail && Array.isArray(errorData.detail)) {
        const errors = errorData.detail.map(err => {
          if (typeof err === 'string') return err;
          const field = err.loc?.join('.') || 'unknown';
          return `${field}: ${err.msg || err.message || JSON.stringify(err)}`;
        });
        message.error(errors.join('; '));
      } else if (typeof errorData?.detail === 'string') {
        message.error(errorData.detail);
      } else if (errorData?.message) {
        message.error(errorData.message);
      } else if (typeof errorData === 'string') {
        message.error(errorData);
      } else {
        message.error('操作失败，请检查输入数据');
      }
    }
  };

  // 删除模板
  const handleDelete = async (id) => {
    try {
      await api.delete(`/ad-series-templates/${id}`);
      message.success('删除成功');
      fetchTemplates();
    } catch (error) {
      message.error('删除失败');
    }
  };

  // 预览模板
  const handlePreview = async (template) => {
    try {
      const response = await api.get(`/ad-series-templates/${template.id}/preview`);
      setPreviewData(response.data);
      setPreviewVisible(true);
    } catch (error) {
      message.error('获取预览失败');
    }
  };

  // 添加 AdSet
  const addAdSet = () => {
    const newConfigs = [...adSetConfigs, { key: adSetConfigs.length }];
    setAdSetConfigs(newConfigs);
    // 同步更新 adset_count
    form.setFieldsValue({ adset_count: newConfigs.length });
  };

  // 删除 AdSet
  const removeAdSet = (index) => {
    if (adSetConfigs.length <= 1) {
      message.warning('至少需要保留一个 AdSet');
      return;
    }
    const newConfigs = adSetConfigs.filter((_, i) => i !== index);
    setAdSetConfigs(newConfigs);
    // 同步更新 adset_count
    form.setFieldsValue({ adset_count: newConfigs.length });
  };

  // 预算模式切换
  const handleBudgetModeChange = (e) => {
    setBudgetMode(e.target.value);
    form.setFieldsValue({
      campaign_daily_budget: undefined,
      campaign_lifetime_budget: undefined,
    });
  };

  // 打开创建广告模态框
  const handleCreateAd = (template) => {
    setCreateAdTemplate(template);
    createAdForm.resetFields();
    createAdForm.setFieldsValue({
      campaign_name: template.name,
    });
    setCreateAdVisible(true);
  };

  // 提交创建广告
  const handleCreateAdSubmit = async (values) => {
    try {
      const payload = {
        template_id: createAdTemplate.id,
        ad_account_id: values.ad_account_id,
        campaign_name: values.campaign_name,
        adset_names: values.adset_names,
        daily_budget: values.daily_budget,
        start_time: values.start_time?.format(),
        stop_time: values.stop_time?.format(),
      };

      const response = await api.post(`/ad-series-templates/${createAdTemplate.id}/create`, payload);
      
      if (response.data.success) {
        message.success('广告创建成功！');
        setCreateAdVisible(false);
        createAdForm.resetFields();
      } else {
        const errors = response.data.errors || [];
        message.error('创建失败: ' + errors.join('; '));
      }
    } catch (error) {
      const errorData = error.response?.data;
      if (errorData?.detail && Array.isArray(errorData.detail)) {
        const errors = errorData.detail.map(err => {
          const field = err.loc?.join('.') || 'unknown';
          return `${field}: ${err.msg}`;
        });
        message.error(errors.join('; '));
      } else if (typeof errorData?.detail === 'string') {
        message.error(errorData.detail);
      } else {
        message.error('创建广告失败');
      }
    }
  };

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '广告目标',
      dataIndex: 'objective',
      key: 'objective',
      render: (objective) => {
        const obj = objectives.find(o => o.value === objective);
        return <Tag color="blue">{obj?.label || objective}</Tag>;
      },
    },
    {
      title: '预算模式',
      dataIndex: 'budget_mode',
      key: 'budget_mode',
      render: (mode) => (
        <Tag color={mode === 'CBO' ? 'green' : 'orange'}>
          {mode === 'CBO' ? 'CBO系列预算' : 'ABO广告组预算'}
        </Tag>
      ),
    },
    {
      title: '共享预算',
      dataIndex: 'advantage_campaign_budget',
      key: 'advantage_campaign_budget',
      render: (value) => (
        <Tag color={value ? 'green' : 'default'}>
          {value ? '已开启' : '未开启'}
        </Tag>
      ),
    },
    {
      title: '竞价策略',
      dataIndex: 'campaign_bid_strategy',
      key: 'campaign_bid_strategy',
      render: (strategy) => {
        const s = campaignBidStrategies.find(o => o.value === strategy);
        return <Tag color="purple">{s?.label || strategy}</Tag>;
      },
    },
    {
      title: '数量配置',
      key: 'quantity',
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Tag color="blue">{record.adset_count || 1} 组</Tag>
          <Tag color="green">{record.ad_per_adset || 1} 广告/组</Tag>
          <Tag color="orange">{record.material_per_ad || 1} 素材/广告</Tag>
        </Space>
      ),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? '正常' : '停用'}
        </Tag>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<RocketOutlined />}
            onClick={() => handleCreateAd(record)}
            size="small"
          >
            创建广告
          </Button>
          <Button
            icon={<EyeOutlined />}
            onClick={() => handlePreview(record)}
            size="small"
          >
            预览
          </Button>
          <Button
            icon={<EditOutlined />}
            onClick={async () => {
              try {
                const response = await api.get(`/ad-series-templates/${record.id}`);
                const template = response.data;
                setEditingTemplate(template);
                isInitialEditLoad.current = true;

                form.setFieldsValue({
                  name: template.name,
                  description: template.description,
                  objective: template.objective,
                  budget_mode: template.budget_mode,
                  buying_type: template.buying_type,
                  campaign_daily_budget: template.campaign_daily_budget,
                  campaign_lifetime_budget: template.campaign_lifetime_budget,
                  bid_strategy: template.bid_strategy,
                  bid_amount: template.bid_amount,
                  advantage_campaign_budget: template.advantage_campaign_budget,
                  campaign_bid_strategy: template.campaign_bid_strategy,
                  special_ad_categories: template.special_ad_categories,
                  campaign_start_time: template.campaign_start_time,
                  campaign_stop_time: template.campaign_stop_time,
                  adset_count: template.adset_count,
                  ad_per_adset: template.ad_per_adset,
                  material_per_ad: template.material_per_ad,
                  body_count: template.body_count ?? 5,
                  headline_count: template.headline_count ?? 5,
                  description_count: template.description_count ?? 5,
                  message_template: template.message_template,
                  headline_template: template.headline_template,
                  call_to_action: template.call_to_action,
                  link_url: template.link_url,
                  page_id: template.page_id,
                });

                const adsetCount = template.adset_configs?.length || 1;
                const newAdSetConfigs = Array.from({ length: adsetCount }, (_, i) => ({ key: i }));
                setAdSetConfigs(newAdSetConfigs);

                setBudgetMode(template.budget_mode);
                setCurrentStep(0);
                setModalVisible(true);
              } catch (error) {
                message.error('加载模板详情失败');
              }
            }}
            size="small"
          >
            编辑
          </Button>
          <Popconfirm
            title="确定删除吗？"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button icon={<DeleteOutlined />} danger size="small">删除</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // 步骤内容
  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="模板名称"
                  rules={[{ required: true, message: '请输入模板名称' }]}
                >
                  <Input placeholder="输入模板名称" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="objective"
                  label="广告目标"
                  initialValue="OUTCOME_TRAFFIC"
                >
                  <Select>
                    {objectives.map(obj => (
                      <Option key={obj.value} value={obj.value}>{obj.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="description"
              label="描述"
            >
              <TextArea rows={2} placeholder="模板描述（可选）" />
            </Form.Item>

            <Divider>预算设置</Divider>

            <Form.Item
              name="budget_mode"
              label="预算模式"
              initialValue="CBO"
            >
              <Radio.Group onChange={handleBudgetModeChange}>
                <Radio value="CBO">
                  <Tag color="green">CBO</Tag> 系列预算优化 - Facebook自动分配预算到各广告组
                </Radio>
                <Radio value="ABO">
                  <Tag color="orange">ABO</Tag> 广告组预算 - 手动设置每个广告组预算
                </Radio>
              </Radio.Group>
            </Form.Item>

            {budgetMode === 'CBO' && (
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="campaign_daily_budget"
                    label="每日预算 (USD)"
                  >
                    <InputNumber min={1} style={{ width: '100%' }} placeholder="CBO模式下的系列日预算" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="campaign_lifetime_budget"
                    label="总预算 (USD)"
                  >
                    <InputNumber min={1} style={{ width: '100%' }} placeholder="或设置总预算" />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="buying_type"
                  label="购买类型"
                  initialValue="AUCTION"
                >
                  <Select>
                    <Option value="AUCTION">竞拍</Option>
                    <Option value="RESERVED">预留</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="bid_strategy"
                  label="出价策略"
                  initialValue="LOWEST_COST_WITHOUT_CAP"
                >
                  <Select>
                    {bidStrategies.map(s => (
                      <Option key={s.value} value={s.value}>{s.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="bid_amount"
                  label="出价金额"
                >
                  <InputNumber min={0} style={{ width: '100%' }} placeholder="可选" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="advantage_campaign_budget"
                  valuePropName="checked"
                  initialValue={true}
                >
                  <Checkbox>
                    把你的部分预算共享给其他广告组
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="campaign_bid_strategy"
                  label="广告系列竞价策略"
                  initialValue="HIGHEST_VOLUME_OR_VALUE"
                >
                  <Select>
                    {campaignBidStrategies.map(strategy => (
                      <Option key={strategy.value} value={strategy.value}>
                        {strategy.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="special_ad_categories"
              label="特殊广告类别"
            >
              <Checkbox.Group>
                <Checkbox value="HOUSING">住房</Checkbox>
                <Checkbox value="EMPLOYMENT">就业</Checkbox>
                <Checkbox value="CREDIT">信贷</Checkbox>
                <Checkbox value="ISSUES_ELECTIONS_POLITICS">政治议题</Checkbox>
              </Checkbox.Group>
            </Form.Item>

            <Divider>数量配置</Divider>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="adset_count"
                  label="AdSet 数量"
                  initialValue={1}
                  rules={[{ required: true, message: '请输入AdSet数量' }]}
                >
                  <InputNumber min={1} max={50} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="ad_per_adset"
                  label="每组广告数"
                  initialValue={1}
                  rules={[{ required: true, message: '请输入每组广告数' }]}
                >
                  <InputNumber min={1} max={50} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="material_per_ad"
                  label="每广告素材数"
                  initialValue={1}
                  rules={[{ required: true, message: '请输入每广告素材数' }]}
                >
                  <InputNumber min={1} max={50} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>

            <Divider style={{ margin: '16px 0' }} />

            <Typography.Title level={4} style={{ marginBottom: 16 }}>文案数量配置</Typography.Title>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="body_count"
                  label="正文数量"
                  initialValue={5}
                  rules={[{ required: true, message: '请输入正文数量' }]}
                >
                  <InputNumber min={1} max={20} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="headline_count"
                  label="标题数量"
                  initialValue={5}
                  rules={[{ required: true, message: '请输入标题数量' }]}
                >
                  <InputNumber min={1} max={20} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="description_count"
                  label="描述数量"
                  initialValue={5}
                  rules={[{ required: true, message: '请输入描述数量' }]}
                >
                  <InputNumber min={1} max={20} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        );

      case 1:
        return (
          <div>
            {adSetConfigs.map((adSet, index) => (
              <Card
                key={adSet.key}
                title={
                  <Space>
                    <span>AdSet {index + 1}</span>
                    {adSetConfigs.length > 1 && (
                      <Button
                        type="link"
                        danger
                        icon={<MinusCircleOutlined />}
                        onClick={() => removeAdSet(index)}
                      >
                        删除
                      </Button>
                    )}
                  </Space>
                }
                style={{ marginBottom: 16 }}
              >
                <Form.Item
                  name={`adset_name_${index}`}
                  label="AdSet 名称"
                  rules={[{ required: true, message: '请输入 AdSet 名称' }]}
                >
                  <Input placeholder={`例如：AdSet ${index + 1} - 美国`} />
                </Form.Item>

                {budgetMode === 'ABO' && (
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name={`adset_daily_budget_${index}`}
                        label="每日预算 (USD)"
                      >
                        <InputNumber min={1} style={{ width: '100%' }} placeholder="ABO模式下的广告组预算" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name={`adset_lifetime_budget_${index}`}
                        label="总预算 (USD)"
                      >
                        <InputNumber min={1} style={{ width: '100%' }} placeholder="或设置总预算" />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      name={`adset_bid_amount_${index}`}
                      label="出价金额"
                    >
                      <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name={`adset_bid_strategy_${index}`}
                      label="出价策略"
                      initialValue="LOWEST_COST_WITHOUT_CAP"
                    >
                      <Select>
                        {bidStrategies.map(s => (
                          <Option key={s.value} value={s.value}>{s.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name={`adset_billing_event_${index}`}
                      label="计费事件"
                      initialValue="IMPRESSIONS"
                    >
                      <Select>
                        {billingEvents.map(e => (
                          <Option key={e.value} value={e.value}>{e.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name={`adset_optimization_goal_${index}`}
                  label="优化目标"
                  initialValue="LINK_CLICKS"
                >
                  <Select>
                    {optimizationGoals.map(g => (
                      <Option key={g.value} value={g.value}>{g.label}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Divider>转化设置</Divider>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_conversion_location_${index}`}
                      label="转化发生位置"
                      initialValue="WEBSITE"
                    >
                      <Select placeholder="选择转化发生位置">
                        {conversionLocations.map(l => (
                          <Option key={l.value} value={l.value}>{l.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_performance_goal_${index}`}
                      label="成效目标"
                      initialValue="CONVERSIONS"
                    >
                      <Select placeholder="选择成效目标">
                        {performanceGoals.map(g => (
                          <Option key={g.value} value={g.value}>{g.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_pixel_id_${index}`}
                      label="数据集 (Pixel ID)"
                    >
                      <Select
                        placeholder="选择Pixel ID"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        {pixels.map(p => (
                          <Option key={p.pixel_id} value={p.pixel_id}>
                            {p.name ? `${p.name} (${p.pixel_id})` : p.pixel_id}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_conversion_event_${index}`}
                      label="转化事件"
                      initialValue="PURCHASE"
                    >
                      <Select placeholder="选择转化事件">
                        <Option value="PURCHASE">购买</Option>
                        <Option value="ADD_TO_CART">加购</Option>
                        <Option value="INITIATE_CHECKOUT">发起结账</Option>
                        <Option value="LEAD">潜在客户</Option>
                        <Option value="COMPLETE_REGISTRATION">完成注册</Option>
                        <Option value="VIEW_CONTENT">查看内容</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name={`adset_attribution_setting_${index}`}
                  label="归因设置"
                  initialValue="7D_CLICK_1D_VIEW"
                >
                  <Select placeholder="选择归因设置">
                    {attributionSettings.map(a => (
                      <Option key={a.value} value={a.value}>{a.label}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Divider>定向设置</Divider>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_age_min_${index}`}
                      label="最小年龄"
                      initialValue={18}
                    >
                      <InputNumber min={13} max={65} style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_age_max_${index}`}
                      label="最大年龄"
                      initialValue={65}
                    >
                      <InputNumber min={13} max={65} style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name={`adset_genders_${index}`}
                  label="性别"
                  initialValue={[0, 1]}
                >
                  <Checkbox.Group>
                    <Checkbox value={0}>女性</Checkbox>
                    <Checkbox value={1}>男性</Checkbox>
                  </Checkbox.Group>
                </Form.Item>

                <Form.Item
                  name={`adset_countries_${index}`}
                  label="国家"
                  initialValue={['US']}
                >
                  <Select mode="multiple" placeholder="选择国家">
                    {countries.map(c => (
                      <Option key={c.value} value={c.value}>{c.label}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={`adset_languages_${index}`}
                  label="语言"
                  initialValue={[]}
                >
                  <Select
                    mode="multiple"
                    placeholder="输入关键词搜索语言，如：英语、中文"
                    showSearch
                    filterOption={false}
                    onSearch={(value) => {
                      console.log('onSearch triggered:', value);
                      debounceSearchLocales(value);
                    }}
                    onFocus={() => {
                      console.log('Select focused, current options:', localeOptions);
                      // 聚焦时如果为空，搜索一个默认值
                      if (localeOptions.length === 0) {
                        debounceSearchLocales('英语');
                      }
                    }}
                    notFoundContent={searchingLocales ? '搜索中...' : '输入关键词搜索语言'}
                    labelInValue
                    options={localeOptions.map(l => ({
                      value: String(l.id),
                      label: l.name
                    }))}
                  />
                </Form.Item>

                <Form.Item
                  name={`adset_interests_${index}`}
                  label="兴趣细分定位"
                  initialValue={[]}
                >
                  <Select
                    mode="multiple"
                    placeholder="输入关键词搜索兴趣"
                    showSearch
                    filterOption={false}
                    onSearch={debounceSearchInterests}
                    notFoundContent={searchingInterests ? '搜索中...' : '输入关键词搜索'}
                    labelInValue
                    options={interestOptions.map(i => ({
                      value: i.id,
                      label: `${i.name}${i.audience_size ? ` (${(i.audience_size / 1000000).toFixed(1)}M)` : ''}`
                    }))}
                  />
                </Form.Item>

                <Form.Item
                  name={`adset_behaviors_${index}`}
                  label="行为细分定位"
                  initialValue={[]}
                >
                  <Select
                    mode="multiple"
                    placeholder="输入关键词搜索行为"
                    showSearch
                    filterOption={false}
                    onSearch={debounceSearchBehaviors}
                    notFoundContent={searchingBehaviors ? '搜索中...' : '输入关键词搜索'}
                    labelInValue
                    options={behaviorOptions.map(b => ({
                      value: b.id,
                      label: b.name
                    }))}
                  />
                </Form.Item>

                <Form.Item
                  name={`adset_platforms_${index}`}
                  label="投放平台"
                  initialValue={['facebook', 'instagram']}
                >
                  <Checkbox.Group>
                    <Checkbox value="facebook">Facebook</Checkbox>
                    <Checkbox value="instagram">Instagram</Checkbox>
                    <Checkbox value="audience_network">Audience Network</Checkbox>
                    <Checkbox value="messenger">Messenger</Checkbox>
                  </Checkbox.Group>
                </Form.Item>

                <Divider>设备和操作系统</Divider>

                <Form.Item
                  name={`adset_advantage_audience_${index}`}
                  label="赋能型受众功能"
                  initialValue={0}
                >
                  <Select>
                    <Option value={0}>关闭</Option>
                    <Option value={1}>开启</Option>
                  </Select>
                </Form.Item>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_devices_${index}`}
                      label="设备"
                      initialValue={['mobile', 'desktop']}
                    >
                      <Checkbox.Group>
                        {devices.map(d => (
                          <Checkbox key={d.value} value={d.value}>{d.label}</Checkbox>
                        ))}
                      </Checkbox.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_os_${index}`}
                      label="操作系统"
                      initialValue={[]}
                    >
                      <Select mode="multiple" placeholder="选择操作系统">
                        {operatingSystems.map(o => (
                          <Option key={o.value} value={o.value}>{o.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_start_time_${index}`}
                      label="开始时间"
                    >
                      <DatePicker showTime style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={`adset_end_time_${index}`}
                      label="结束时间"
                    >
                      <DatePicker showTime style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            ))}

            <Button
              type="dashed"
              onClick={addAdSet}
              block
              icon={<PlusCircleOutlined />}
            >
              添加 AdSet
            </Button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <Card
        title="广告系列模板"
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingTemplate(null);
              form.resetFields();
              setAdSetConfigs([{ key: 0 }]);
              setCurrentStep(0);
              setBudgetMode('CBO');
              setModalVisible(true);
            }}
          >
            创建模板
          </Button>
        }
      >
        <Table
          columns={columns}
          dataSource={templates}
          rowKey="id"
          loading={loading}
        />
      </Card>

      {/* 创建/编辑模态框 */}
      <Modal
        title={editingTemplate ? '编辑模板' : '创建广告系列模板'}
        open={modalVisible}
        onOk={() => {
          if (currentStep === 0) {
            handleSaveCampaign();
          } else {
            form.submit();
          }
        }}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
          setAdSetConfigs([{ key: 0 }]);
          setCurrentStep(0);
          setEditingTemplate(null);
          setBudgetMode('CBO');
          isInitialEditLoad.current = false;
        }}
        width={900}
        okText={currentStep === 0 ? '下一步' : '保存'}
        cancelText={currentStep === 0 ? '取消' : '上一步'}
        cancelButtonProps={{
          onClick: () => {
            if (currentStep === 1) {
              setCurrentStep(0);
            } else {
              setModalVisible(false);
              form.resetFields();
              setAdSetConfigs([{ key: 0 }]);
              setCurrentStep(0);
              setEditingTemplate(null);
              setBudgetMode('CBO');
              isInitialEditLoad.current = false;
            }
          }
        }}
      >
        <Form
          form={form}
          preserve
          onFinish={handleSubmit}
          layout="vertical"
        >
          <Steps
            current={currentStep}
            style={{ marginBottom: 24 }}
          >
            <Step title="Campaign 设置" />
            <Step title="AdSet 设置" />
          </Steps>

          {renderStepContent()}
        </Form>
      </Modal>

      {/* 预览模态框 */}
      <Modal
        title="模板预览"
        open={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        width={800}
        footer={null}
      >
        {previewData && (
          <div>
            <Card title="Campaign 配置" size="small">
              <p><strong>名称：</strong>{previewData.template_name}</p>
              <p><strong>目标：</strong>{previewData.campaign?.objective}</p>
              <p><strong>预算模式：</strong>{previewData.budget_mode}</p>
              <p><strong>共享预算：</strong>{previewData.campaign?.advantage_campaign_budget ? '已开启' : '未开启'}</p>
              <p><strong>竞价策略：</strong>{previewData.campaign?.campaign_bid_strategy}</p>
              <p><strong>AdSet数量：</strong>{previewData.adset_count || 1}</p>
              <p><strong>每组广告数：</strong>{previewData.ad_per_adset || 1}</p>
              <p><strong>每广告素材数：</strong>{previewData.material_per_ad || 1}</p>
            </Card>

            <Divider />

            <Collapse>
              {previewData.adsets?.map((adset, index) => (
                <Panel header={`AdSet ${index + 1}: ${adset.name}`} key={index}>
                  <p><strong>预算：</strong>${adset.daily_budget || adset.lifetime_budget || 0}</p>
                  <p><strong>出价：</strong>${adset.bid_amount || 0}</p>
                  <p><strong>优化目标：</strong>{adset.optimization_goal}</p>
                  <p><strong>计费事件：</strong>{adset.billing_event}</p>
                  
                  <Divider orientation="left">定向</Divider>
                  <pre>{JSON.stringify(adset.targeting, null, 2)}</pre>
                </Panel>
              ))}
            </Collapse>

            {previewData.creatives && previewData.creatives.length > 0 && (
              <>
                <Divider />
                <Card title="广告创意" size="small">
                  {previewData.creatives.map((creative, index) => (
                    <div key={index}>
                      <p><strong>素材：</strong>{creative.material_name}</p>
                      <p><strong>正文：</strong>{creative.creative?.object_story_spec?.link_data?.message}</p>
                      <p><strong>标题：</strong>{creative.creative?.object_story_spec?.link_data?.name}</p>
                      <p><strong>链接：</strong>{creative.creative?.object_story_spec?.link_data?.link}</p>
                    </div>
                  ))}
                </Card>
              </>
            )}
          </div>
        )}
      </Modal>

      {/* 创建广告模态框 */}
      <Modal
        title={`使用模板创建广告 - ${createAdTemplate?.name || ''}`}
        open={createAdVisible}
        onOk={() => createAdForm.submit()}
        onCancel={() => {
          setCreateAdVisible(false);
          createAdForm.resetFields();
          setCreateAdTemplate(null);
        }}
        width={600}
        okText="创建广告"
        cancelText="取消"
      >
        <Form
          form={createAdForm}
          onFinish={handleCreateAdSubmit}
          layout="vertical"
        >
          <Form.Item
            name="ad_account_id"
            label="选择广告账户"
            rules={[{ required: true, message: '请选择广告账户' }]}
          >
            <Select placeholder="选择广告账户">
              {adAccounts.map(account => (
                <Option key={account.id} value={account.account_id}>
                  {account.name} ({account.account_id})
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="campaign_name"
            label="Campaign 名称"
            rules={[{ required: true, message: '请输入Campaign名称' }]}
          >
            <Input placeholder="输入Campaign名称" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="daily_budget"
                label="每日预算 (USD)"
              >
                <InputNumber min={1} style={{ width: '100%' }} placeholder="可选，覆盖模板预算" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="start_time"
                label="开始时间"
              >
                <DatePicker showTime style={{ width: '100%' }} placeholder="可选" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="stop_time"
                label="结束时间"
              >
                <DatePicker showTime style={{ width: '100%' }} placeholder="可选" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="adset_names"
            label="自定义AdSet名称"
          >
            <Select mode="tags" placeholder="输入自定义AdSet名称（可选）">
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AdSeriesTemplates;
